import { useState } from 'react';
import { User } from '@/types/auth';
import { useUserStore } from '@/store/userStore';
import * as userApi from '@/lib/api/users';

export const useUserManagement = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { fetchUsers } = useUserStore();

  const updateUser = async (userId: string, data: Partial<User>) => {
    setIsLoading(true);
    setError(null);
    
    try {
      await userApi.updateUserProfile(userId, data);
      await fetchUsers(); // Refresh list after update
      return true;
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Failed to update user';
      setError(message);
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  const deleteUser = async (userId: string) => {
    setIsLoading(true);
    setError(null);
    
    try {
      await userApi.deactivateUser(userId);
      await fetchUsers(); // Refresh list after deletion
      return true;
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Failed to delete user';
      setError(message);
      throw err;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    updateUser,
    deleteUser,
    isLoading,
    error
  };
};